import { CustomerProcedureInterface } from '../../models/customer-procedure.interface';

export interface CustomerProcedureInterfaceState {
  customerProcedures: Array<CustomerProcedureInterface>;
}

export const initialCustomerProcedureState: CustomerProcedureInterfaceState = {
  customerProcedures: null
};
